import logoDark from "../../assets/images/logoerpbridge.png";
import logoLight from "../../assets/images/logoerpbridge-w.png";
import erpSyncLogoDark from "../../assets/images/Logo-ErpSync.svg";
import erpSyncLogoLight from "../../assets/images/Logo-ERPSync-White.svg";
import { BRAND } from "../../services/brand";

interface BrandLogoProps {
  light?: boolean;
  className?: string;
}

const BrandLogo = ({ light = false, className = "" }: BrandLogoProps) => {
  const logo = BRAND.key === "erpsync"
    ? (light ? erpSyncLogoLight : erpSyncLogoDark)
    : (light ? logoLight : logoDark);

  return <img src={logo} alt={BRAND.compactName} className={className} />;
};

export default BrandLogo;
